import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { LoadingDialogService } from "src/app/shared/services/loading-dialog.service";

@Injectable({
  providedIn: 'root'
})
export class MapSidebarService {

  constructor(private loadingDialogService: LoadingDialogService) {

  }

  private _isOpenSubject = new BehaviorSubject(false);

  isOpen$ = this._isOpenSubject.asObservable();

  get isOpen() {
    return this._isOpenSubject.value;
  }

  toggleMapVisibility() {
    this._isOpenSubject.next(!this._isOpenSubject.value);
  }

  private _periodSubject = new BehaviorSubject<number | string | null>(null);

  period$ = this._periodSubject.asObservable()

  get period() {
    return this._periodSubject.value;
  }

  setPeriod(val: number | string) {
    this._periodSubject.next(val)
  }
}